import { type SidebarEntry } from './SidebarBuilder'

export function findSidebarEntry(
  sidebarEntries: SidebarEntry[],
  recordName: string,
  parent: SidebarEntry | undefined = undefined
): { entry: SidebarEntry | undefined; parent: SidebarEntry | undefined } {
  for (const entry of sidebarEntries) {
    if (entry.recordName === recordName) {
      return { entry, parent }
    } else if (entry.children) {
      const result = findSidebarEntry(entry.children, recordName, entry)
      if (result.entry) {
        return result
      }
    }
  }

  return { entry: undefined, parent: undefined }
}
